export const employeeCountTypes = [
  {
    displayvalue: 1,
    displayname: "Location",
  },
  {
    displayvalue: 2,
    displayname: "Department",
  },
  {
    displayvalue: 3,
    displayname: "Education",
  },
  {
    displayvalue: 4,
    displayname: "Business unit",
  },
  {
    displayvalue: 5,
    displayname: "Hired in year",
  },
  {
    displayvalue: 6,
    displayname: "Grade",
  },
  {
    displayvalue: 7,
    displayname: "Gender",
  },
  {
    displayvalue: 8,
    displayname: "Marital status",
  },
  {
    displayvalue: 9,
    displayname: "Age group",
  },
];

export const filterTypes = [
  {
    displayvalue: 1,
    displayname: "This quarter",
  },
  {
    displayvalue: 2,
    displayname: "Previous quarter",
  },
  {
    displayvalue: 3,
    displayname: "This year",
  },
  {
    displayvalue: 4,
    displayname: "Previous year",
  },
  {
    displayvalue: 5,
    displayname: "Past 3 years",
  },
];

export const subfilterTypes = [
  {
    displayvalue: 1,
    displayname: "Organisation",
  },
  {
    displayvalue: 2,
    displayname: "Business unit",
  },
  {
    displayvalue: 3,
    displayname: "Department",
  },
  {
    displayvalue: 4,
    displayname: "Location",
  },
];

export const requestCountTypes = [
  {
    displayvalue: 6,
    displayname: "Today",
  },
  {
    displayvalue: 7,
    displayname: "This week",
  },
  {
    displayvalue: 8,
    displayname: "This month",
  },
];

export const attendanceStateTypes = [
  {
    displayvalue: 1,
    displayname: "Time at work",
  },
  {
    displayvalue: 2,
    displayname: "Late by",
  },
  {
    displayvalue: 3,
    displayname: "Over time",
  },
];
